import React from 'react';

import { useNavigate } from 'react-router-dom';

import { Row, Col } from 'react-bootstrap';

import ApplicationLayout from 'v3/layouts/Application';
import Space from 'v3/components/Space';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';

import Data from './Data';

export default function RasterBranchesDetails() {
  const navigate = useNavigate();

  return (
    <ApplicationLayout
      title="Filial Raster"
      RightComponent={
        <Space x="4px">
          <Button variant="secondary" onClick={() => navigate(-1)}>
            <Text color="dark" weight={500} type="regular">
              Voltar
            </Text>
          </Button>
          <Button onClick={() => navigate('/filiais-raster/cadastrar')}>
            <Text color="white" weight={500} type="regular">
              Nova filial
            </Text>
          </Button>
        </Space>
      }
    >
      <Row>
        <Col xs={12} md={6}>
          <Data />
        </Col>
      </Row>
    </ApplicationLayout>
  );
}
